/*
 * Created on Thu Oct 12 2023 10:21:49 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { combineReducers } from "redux";
import auth from './auth'
import products from './products'
import courseSchedules from './courseSchedules'
import companyReducer from "./companyReducer";
import cardProductDetails from "./cartReducer"
import selectedProdctReducer from "./selectedProductReducer";
import shoppingCartReducer from "./shoppingCartReducer";
import orderReducer from "./orderReducer";
import selectedBranch from "./selectedBranch";

const combinedReducers = combineReducers({
    auth,
    products,
    courseSchedules,
    companyReducer,
    selectedBranch,
    order: orderReducer,
    cardProducts: cardProductDetails,
    selectedProduct: selectedProdctReducer,
    shoppingCart: shoppingCartReducer,

});

const reducers = (state, action) => {
    if (action.type === "LOGOUT") {
        const companyState = state?.companyReducer;
        const nextState = combinedReducers(undefined, action);
        return {
            ...nextState,
            // Public company/site data is not user-owned and should remain
            // mounted during SPA logout so branding does not flicker.
            companyReducer: companyState,
        };
    }

    return combinedReducers(state, action);
};

export default reducers;

